/* eslint-disable */
export default {
    result: {
        'error': 0,
        'msg': 'OK'
    },
    content: {
        'feeds': [
            {
                'feed_id': '37033',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400131908301567148928XX',
                'like_num': 373,
                'share_num': '205',
                'introduce': '神农顶景区拥有联合国教科文组织人和生物圈保护区网络成员、世界自然遗产、世界地质公园、是神农架风景最优美、生物多样性最丰富的地区、生态价值最重要，以“原始、生态、神奇、神秘”为显著特点。主要景点包括景区大门--鸭子口、金候部落--大龙潭、科普乐园--小龙潭、原始森林--金猴岭、追溪溯源--神农源、苍源碧海--神农营、奇云叠谷--神农谷、、海燕冬栖--金丝燕洞、、林海漫步等13个景点',
                'address': '神农架林区-神农顶风景区-神农顶-神农营',
                'type': 2,
                'tab_type': '',
                'uid': '61d5144b3ade6097882fb5db',
                'is_like': false,
                'topic': [],
                'view_dir': '329.09,32.33',
                'content_type': 0,
                'heading': '329.09',
                'pitch': '32.33',
                'pano_name': '神农营',
                'uid_name': '神农顶风景区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400131908301567148928XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400131908301567148928XX&heading=329.09&pitch=32.33',
                'ext_info': [],
                'status': '2',
                "feed_title": "我爱北京天安门$#$冲锋"
            },
            {
                "feed_id": "8222480",
                "strategy": "",
                "reason": "",
                "pid": "v0144442303231679551663OI",
                "like_num": 0,
                "share_num": "0",
                "introduce": "",
                "address": "xxx",
                "type": "4",
                "tab_type": "",
                "uid": "",
                "is_like": false,
                "topic": [],
                "view_dir": "",
                "content_type": 0,
                "heading": 0,
                "pitch": 0,
                "loc": "",
                "pano_name": "",
                "uid_name": "",
                "imgurl": "http://bj.bcebos.com/quanjing-video/normal-video/v01444/v0144442303231679551664OI.jpg",
                "videourl": "http://bj.bcebos.com/quanjing-video/normal-video/v01444/v0144442303231679551663OI.mp4",
                "ext_info": [],
                "enable": "0",
                "feed_title": "",
                "addr_link": ""
            },
            {
                'feed_id': '57541',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132005091707173498XX',
                'like_num': 15408,
                'share_num': '2050',
                'introduce': '孔林占地近200万平方米，有坟冢10万余座，有神道与城门相连。孔子墓位于孔林中部，封土呈偃斧形，汉代设祠坛建神门，宋代刻制石仪，元代立碑、作周垣、建重门，明代重建享殿墓门、添建洙水桥坊和万古长春坊。孔林丰富的地上文物，对于研究中国墓葬制度的沿革和古代政治、经济、文化、风俗、书法、艺术等都具有很高的价值。',
                'address': '济宁市-孔林-墓门',
                'type': 2,
                'tab_type': '',
                'uid': '9f97b1c547728f07b64f540a',
                'is_like': false,
                'topic': [
                    {
                        'id': '7497',
                        'name': '孔林',
                        'type': 'uid',
                        'total': '15',
                        'order': 2
                    }
                ],
                'view_dir': '198.45,11.89',
                'content_type': 0,
                'heading': '198.45',
                'pitch': '11.89',
                'pano_name': '墓门',
                'uid_name': '孔林',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132005091707173498XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132005091707173498XX&heading=198.45&pitch=11.89',
                'ext_info': [],
                'status': '2',
                "feed_title": "我爱北京天安门$#$冲锋"
            },
            {
                'feed_id': '193026',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132201261349140962XX',
                'like_num': 3389,
                'share_num': '879',
                'introduce': '内蒙古阿尔山国家森林公园位于内蒙古大兴安岭西南麓，是2000年2月22日经国家林业局正式批准成立的，总面积103149公顷',
                'address': '兴安盟-好森沟风景区-大峡谷1',
                'type': 2,
                'tab_type': '',
                'uid': '680fb70350564b9f8ab988a1',
                'is_like': false,
                'topic': [],
                'view_dir': '264.14,0.12',
                'content_type': 0,
                'heading': '264.14',
                'pitch': '0.12',
                'pano_name': '大峡谷1',
                'uid_name': '好森沟风景区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132201261349140962XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132201261349140962XX&heading=264.14&pitch=0.12',
                'ext_info': [],
                'status': '2',
                "feed_title": "我爱北京天安门$#$冲锋adjfai"
            },
            {
                'feed_id': '120535',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132011241639166258XX',
                'like_num': 504,
                'share_num': '103',
                'introduce': '西影电影艺术体验中心，坐落于具有60年文艺积淀的西影电影产业集聚区，由电影老爷车博物馆、电影胶片收藏库、大话西游奇妙屋、电影制作技术科普体验区、电影服化道展示体验区、世界电影放映机收藏博物馆、光影互动体验区、西影厂史馆、天明广场、胶片电影工业馆等功能区组成。',
                'address': '西安市-西影电影博物馆-希尔曼',
                'type': 2,
                'tab_type': '',
                'uid': 'ee19fb083af3bb87a80dd841',
                'is_like': false,
                'topic': [],
                'view_dir': '225.55,-0',
                'content_type': 0,
                'heading': '225.55',
                'pitch': '-0',
                'pano_name': '希尔曼',
                'uid_name': '西影电影博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132011241639166258XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132011241639166258XX&heading=225.55&pitch=-0',
                'ext_info': [],
                'status': '2',
                "feed_title": "我爱北京天安门"
            },
            {
                'feed_id': '185928',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132111301427278192XX',
                'like_num': 358,
                'share_num': '86',
                'introduce': '咏竹亭的地址是日照湖州市天荒坪镇五鹤村大竹海',
                'address': '湖州市-咏竹亭',
                'type': 2,
                'tab_type': '',
                'uid': '487c1ed85a0ba8f095f08c0b',
                'is_like': false,
                'topic': [
                    {
                        'id': '6589',
                        'name': '咏竹亭',
                        'type': 'uid',
                        'total': '3',
                        'order': 2
                    }
                ],
                'view_dir': '283.76,-10.55',
                'content_type': 0,
                'heading': '283.76',
                'pitch': '-10.55',
                'pano_name': '咏竹亭',
                'uid_name': '咏竹亭',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132111301427278192XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132111301427278192XX&heading=283.76&pitch=-10.55',
                'ext_info': [],
                'status': '2',
                'status_finish_time': '10:45',
                'jump_url': 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRoot=no&hiddenBackBtn=0&hiddenTitle=1&url=https%3A%2F%2Fscenes.map.baidu.com%2Fstatic%2Fh5-project%2Fmy-upload%2Fmy-upload.html%3Fimg%3Dhttp%253A%252F%252Fbj.bcebos.com%252Fxgc-ugc-bj%252F2445402068%252Fugc24454230216215134085792%252Fugc24454230216215134085792_1_1676555524%252Fperfect%252Fpano_initial.jpg%23%2Fpreview'
            },
            {
                'feed_id': '187768',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132112091959569594XX',
                'like_num': 237,
                'share_num': '58',
                'introduce': '',
                'address': '成都市-成都贺麟故居纪念馆-默认-麟凤家宴',
                'type': 2,
                'tab_type': '',
                'uid': '8100f6248c8865eab6147f3b',
                'is_like': false,
                'topic': [],
                'view_dir': '277.87,3.88',
                'content_type': 0,
                'heading': '277.87',
                'pitch': '3.88',
                'pano_name': '麟凤家宴',
                'uid_name': '成都贺麟故居纪念馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132112091959569594XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132112091959569594XX&heading=277.87&pitch=3.88',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '12:45',
                "feed_title": "我爱北京天安门$#$冲锋"
            },
            {
                'feed_id': '63808',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132005231141472108XX',
                'like_num': 350,
                'share_num': '80',
                'introduce': '灯塔旅游风景区位于风景秀丽的日照海滨，日照市黄海一路东首，南与日照港相邻，东面是碧波万顷、一望无际的黄海，北面与万平口（日照市第二海水浴场）相连。因岸边高高耸立的航海灯塔而得名。',
                'address': '日照市-灯塔景区-灯塔风景区-灯塔近景2',
                'type': 2,
                'tab_type': '',
                'uid': '5c56edd6a9d08727a0d230ae',
                'is_like': false,
                'topic': [
                    {
                        'id': '11234',
                        'name': '日照市七大周边必去地',
                        'type': 'city',
                        'total': '7',
                        'order': 1
                    },
                    {
                        'id': '11235',
                        'name': '日照市七大必打卡地',
                        'type': 'city',
                        'total': '7',
                        'order': 1
                    },
                    {
                        'id': '11236',
                        'name': '日照市七大城市特色打卡地',
                        'type': 'city',
                        'total': '7',
                        'order': 1
                    }
                ],
                'view_dir': '334.19,26.57',
                'content_type': 0,
                'heading': '334.19',
                'pitch': '26.57',
                'pano_name': '灯塔近景2',
                'uid_name': '灯塔景区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132005231141472108XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132005231141472108XX&heading=334.19&pitch=26.57',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '01:45'
            },
            {
                'feed_id': '72203',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132005090928286767XX',
                'like_num': 735,
                'share_num': '194',
                'introduce': '',
                'address': '萍乡市-萍乡武功山国家级风景名胜区-鸟瞰景区-中庵索道',
                'type': 2,
                'tab_type': '',
                'uid': '0ed20a150202559757bffff6',
                'is_like': false,
                'topic': [],
                'view_dir': '69.73,2.84',
                'content_type': 0,
                'heading': '69.73',
                'pitch': '2.84',
                'pano_name': '中庵索道',
                'uid_name': '萍乡武功山国家级风景名胜区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132005090928286767XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132005090928286767XX&heading=69.73&pitch=2.84',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '5:45'
            },
            {
                'feed_id': '40748',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400131910151025591292XX',
                'like_num': 1208,
                'share_num': '403',
                'introduce': '北京黄花城水长城旅游区为国家AAAA级景区，位于北京市怀柔区九渡河镇境内，因三段长城入水而得名，是北京唯一一处长城与水相连的长城。景区距北京市区70公里，怀柔城区35公里。是以奇而著称，以秀为特色，融青山、碧水、长城、古树为一体的旅游休闲胜地。',
                'address': '北京市-黄花城水长城',
                'type': 2,
                'tab_type': '',
                'uid': 'd7fd2ad3fbaf0c540bccdd74',
                'is_like': false,
                'topic': [],
                'view_dir': '192.62,-4.47',
                'content_type': 0,
                'heading': '192.62',
                'pitch': '-4.47',
                'pano_name': '北京市-黄花城水长城',
                'uid_name': '黄花城水长城',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400131910151025591292XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400131910151025591292XX&heading=192.62&pitch=-4.47',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '34:45'
            },
            {
                'feed_id': '136491',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132102221131211013XX',
                'like_num': 190,
                'share_num': '46',
                'introduce': '',
                'address': '成都市-都江堰市博物馆-展览区4',
                'type': 2,
                'tab_type': '',
                'uid': '09f839de6edf84eebb17e7a8',
                'is_like': false,
                'topic': [],
                'view_dir': '236.75,6.75',
                'content_type': 0,
                'heading': '236.75',
                'pitch': '6.75',
                'pano_name': '展览区4',
                'uid_name': '都江堰市博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132102221131211013XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132102221131211013XX&heading=236.75&pitch=6.75',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '04:45'
            },
            {
                'feed_id': '129421',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132012311047595177XX',
                'like_num': 232,
                'share_num': '41',
                'introduce': '中华银杏品种园2004年11月，被郯城县人民政府冠名为“中华银杏品种园”。2014年11月，郯城县重坊镇中华银杏园景区被全国旅游景区质量等级评定委员会正式批准为国家4A级旅游景区',
                'address': '临沂市-中华银杏园',
                'type': 2,
                'tab_type': '',
                'uid': 'b9a0713d57b34bc416a1907c',
                'is_like': false,
                'topic': [
                    {
                        'id': '7708',
                        'name': '中华银杏园',
                        'type': 'uid',
                        'total': '23',
                        'order': 2
                    }
                ],
                'view_dir': '69.03,-1.31',
                'content_type': 0,
                'heading': '69.03',
                'pitch': '-1.31',
                'pano_name': '临沂市-中华银杏园',
                'uid_name': '中华银杏园',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132012311047595177XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132012311047595177XX&heading=69.03&pitch=-1.31',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '07:45'
            },
            {
                'feed_id': '66806',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132004221828479450XX',
                'like_num': 275,
                'share_num': '63',
                'introduce': '乌镇古镇是国家5A级景区，全国二十个黄金周预报景点及江南六大古镇之一。地处浙江省嘉兴市桐乡市北端，西临湖州市南浔区，北接江苏苏州吴江区，为二省（浙江，江苏）三市（嘉兴，湖州，苏州）交界之处。曾名乌墩和青墩，具有六千余年悠久历史。乌镇是典型的江南水乡古镇，素有“鱼米之乡，丝绸之府”之称。',
                'address': '嘉兴市-乌镇风景区-外景-公交船码头',
                'type': 2,
                'tab_type': '',
                'uid': '588267887e49edf421f017ec',
                'is_like': false,
                'topic': [
                    {
                        'id': '6663',
                        'name': '乌镇风景区',
                        'type': 'uid',
                        'total': '39',
                        'order': 2
                    }
                ],
                'view_dir': '290.49,24.65',
                'content_type': 0,
                'heading': '290.49',
                'pitch': '24.65',
                'pano_name': '公交船码头',
                'uid_name': '乌镇风景区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132004221828479450XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132004221828479450XX&heading=290.49&pitch=24.65',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '02:45'
            },
            {
                'feed_id': '64079',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132004171042466421XX',
                'like_num': 188,
                'share_num': '40',
                'introduce': '中国消防博物馆位于北京市丰台区，隶属于应急管理部消防救援局，展陈面积10000平方米，共分三层，由序厅、防火防灾体验厅、文化传承、烈火荣光、国家综合性消防救援队伍的组建、国际交流与合作、会展中心组成。陈列展出了从远古到现代，各个历史时期消防观念、消防组织、消防法制、消防科技世代延续发展的久远历程，以及异彩纷呈的消防文化。',
                'address': '北京市-中国消防博物馆-外景',
                'type': 2,
                'tab_type': '',
                'uid': '72934ad9e02abba3b25c6aba',
                'is_like': false,
                'topic': [],
                'view_dir': '258.11,10.19',
                'content_type': 0,
                'heading': '258.11',
                'pitch': '10.19',
                'pano_name': '外景',
                'uid_name': '中国消防博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132004171042466421XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132004171042466421XX&heading=258.11&pitch=10.19',
                'ext_info': [],
                'status': '0',
                'status_finish_time': '21:45'
            },
            {
                'feed_id': '136373',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132102201007510447XX',
                'like_num': 209,
                'share_num': '38',
                'introduce': '',
                'address': '兰州市-兰州战役纪念馆-入口',
                'type': 2,
                'tab_type': '',
                'uid': '118b086cd969d4993c9a5e3d',
                'is_like': false,
                'topic': [],
                'view_dir': '87.64,27.18',
                'content_type': 0,
                'heading': '87.64',
                'pitch': '27.18',
                'pano_name': '入口',
                'uid_name': '兰州战役纪念馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132102201007510447XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132102201007510447XX&heading=87.64&pitch=27.18',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '51601',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400131912131439222894XX',
                'like_num': 184,
                'share_num': '57',
                'introduce': '开封府，位于河南省开封市包公东湖北岸，是北宋京都官吏行政、司法的衙署，被誉为天下首府，是国家AAAA级旅游景区。',
                'address': '开封市-开封府-议事厅',
                'type': 2,
                'tab_type': '',
                'uid': '5ce2637d3fe8cf51ae31e5c2',
                'is_like': false,
                'topic': [
                    {
                        'id': '11834',
                        'name': '开封市五大登山好去处',
                        'type': 'city',
                        'total': '5',
                        'order': 1
                    },
                    {
                        'id': '6646',
                        'name': '开封府',
                        'type': 'uid',
                        'total': '12',
                        'order': 2
                    }
                ],
                'view_dir': '258.96,10.17',
                'content_type': 0,
                'heading': '258.96',
                'pitch': '10.17',
                'pano_name': '议事厅',
                'uid_name': '开封府',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400131912131439222894XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400131912131439222894XX&heading=258.96&pitch=10.17',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '48799',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400131912101533135407XX',
                'like_num': 120,
                'share_num': '33',
                'introduce': '孔繁森同志纪念馆高15米，为双重檐四周环廊式结构。纪念馆正门上镶嵌着江泽民总书记于1995年7月28日亲笔题写的“孔繁森同志纪念馆”八个大字。纪念厅内安放着孔繁森同志的半身塑像，塑像后屏风上镌刻着江泽民总书记的题词“向孔繁森同志学习”。展厅内布置着孔繁森事迹展览，展览分为6个部分，展出图片270多张，陈列实物千余件，并配以3组电视录像片。纪念馆于1995年9月10日开馆。',
                'address': '聊城市-孔繁森同志纪念馆-展厅-展厅11',
                'type': 2,
                'tab_type': '',
                'uid': '24d0550831bf62ae128824f2',
                'is_like': false,
                'topic': [],
                'view_dir': '190.34,19.13',
                'content_type': 0,
                'heading': '190.34',
                'pitch': '19.13',
                'pano_name': '展厅11',
                'uid_name': '孔繁森同志纪念馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400131912101533135407XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400131912101533135407XX&heading=190.34&pitch=19.13',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '179851',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132110251640571027XX',
                'like_num': 162,
                'share_num': '51',
                'introduce': '',
                'address': '周口市-淮阳太昊陵景区-统天殿',
                'type': 2,
                'tab_type': '',
                'uid': 'fd246495eb760b4e04026f8f',
                'is_like': false,
                'topic': [],
                'view_dir': '273.54,5.38',
                'content_type': 0,
                'heading': '273.54',
                'pitch': '5.38',
                'pano_name': '统天殿',
                'uid_name': '淮阳太昊陵景区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132110251640571027XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132110251640571027XX&heading=273.54&pitch=5.38',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '72340',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132005091136436328XX',
                'like_num': 186,
                'share_num': '37',
                'introduce': '',
                'address': '萍乡市-萍乡武功山国家级风景名胜区-地质博物馆01-矿物岩石区3',
                'type': 2,
                'tab_type': '',
                'uid': '0ed20a150202559757bffff6',
                'is_like': false,
                'topic': [],
                'view_dir': '172.52,-10.33',
                'content_type': 0,
                'heading': '172.52',
                'pitch': '-10.33',
                'pano_name': '矿物岩石区3',
                'uid_name': '萍乡武功山国家级风景名胜区',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132005091136436328XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132005091136436328XX&heading=172.52&pitch=-10.33',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '60293',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132003071615153077XX',
                'like_num': 165,
                'share_num': '44',
                'introduce': '河南省地质博物馆坐落在郑东新区金水东路18号。建筑面积5800平方米。建筑新颖别致，独具风格。馆内设有地球厅、恐龙厅、生物演化厅、古象厅、矿产资源厅、地质环境厅、矿物厅、4D动感影院（多功能厅）和地震海啸感受剧场，馆外有矿石林、科普广场、恐龙雕塑等。目前，馆藏地质资料7357份（种）、13328套；馆藏化石、岩石和矿物标本50000余件，其中展出2193件。这里，可以饱览地球运动造就的自然奇迹。',
                'address': '郑州市-河南自然博物馆-内景-钟乳石',
                'type': 2,
                'tab_type': '',
                'uid': '97d5dc32826d6491eb56fa8f',
                'is_like': false,
                'topic': [],
                'view_dir': '218.68,2.54',
                'content_type': 0,
                'heading': '218.68',
                'pitch': '2.54',
                'pano_name': '钟乳石',
                'uid_name': '河南自然博物馆',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132003071615153077XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132003071615153077XX&heading=218.68&pitch=2.54',
                'ext_info': [],
                'status': '2'
            },
            {
                'feed_id': '216071',
                'strategy': 'userpage',
                'reason': 'userpage',
                'pid': '22444400132204141237367454XX',
                'like_num': 105,
                'share_num': '37',
                'introduce': '古猗园位于上海市西北郊嘉定区南翔镇，始建于明嘉靖年间，原名"猗园"，取自《诗经》中"绿竹猗猗"一句。清乾隆十一年(1746年)，更名"古猗园"。',
                'address': '上海市-古园诏佘猗-青清园门亭-古猗园2',
                'type': 2,
                'tab_type': '',
                'uid': 'ea8d02af61022ab017c8f64c',
                'is_like': false,
                'topic': [],
                'view_dir': '99.94,7.9',
                'content_type': 0,
                'heading': '99.94',
                'pitch': '7.9',
                'pano_name': '古猗园2',
                'uid_name': '古园诏佘猗-青清园门亭',
                'imgurl': 'https://mapsv0.bdimg.com/scape/?qt=pdata&sid=22444400132204141237367454XX&pos=0_0&z=0&from=userpage',
                'imgcover': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=80&width=576&height=1024&from=userpage&panoid=22444400132204141237367454XX&heading=99.94&pitch=7.9',
                'ext_info': [],
                'status': '2'
            }
        ],
        'total': 1000
    }

};